module.exports = __webpack_public_path__ + "static/saas-b324dd802389c66b05d2da70122f601f.png";